// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  actual: 'femhel',
  salarioMinimo: 1423500,
  entidad: {
    clientes: {
      urlLogo: 'https://cyfsoluciones.com/wp-content/uploads/logo.jpg',
      heightLogo: 70,
      urlEndPoint: 'https://app1.usabilidad.co:3001/',
      urlEndPointLegacy: '',
      colorMenu: '#233972',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Cyf',
      nombreFondoCompleto: 'Cyf soluciones',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: false,
      enlaceCrearCuenta: false,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    cyf: {
      urlLogo: 'https://cyfsoluciones.com/wp-content/uploads/logo.jpg',
      heightLogo: 70,
      urlEndPoint: 'https://app1.usabilidad.co:3001/',
      urlEndPointLegacy: '',
      colorMenu: '#233972',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Cyf',
      nombreFondoCompleto: 'Cyf soluciones',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fesfa: {
      urlLogo: 'https://www.fesfa.co/wp-content/uploads/2021/08/logo-fesfa-2-139x115.png',
      heightLogo: 100,
      //urlEndPoint: 'http://localhost:3026/',
      urlEndPoint: 'https://app1.usabilidad.co:3026/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fesfa/Apis/apitest/zonap/api/',
      colorMenu: '#BD2B6E',
      letraColor: '#fff',
      activaActualizacionDatos: true,
      entidadNombre: 'Fesfa',
      nombreFondoCompleto: 'Fondo de empleados del sector farmacéutico',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fesfa/frm_pagos.php',
      actualizacionLegacy: true,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fesfa/',
      solicitudLegacy: true,
      endPointSolicitud: 'https://fesfa.cyfsoluciones.co/solicitudes/',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedane@dane.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: 'https://private.fesfa.co/documentos/DECEVAL.pdf'
    },
    colaborar: {
      urlLogo: 'https://colaborar.org.co/skins/page/images/LogoElegidoColaborar-01.png',
      heightLogo: 80,
      //urlEndPoint: 'https://app1.usabilidad.co:3025/',
      urlEndPoint: 'http://localhost:3025/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/colaborar/zonapnvo/Apis/apitest/zonap/api/',
      colorMenu: '#00448c',
      letraColor: '#fff',
      activaActualizacionDatos: true,
      entidadNombre: 'Colaborar',
      nombreFondoCompleto: 'COOPERATIVA FAMILIA HENKEL COLOMBIANA S.A.S. COLABORAR LTDA',
      backgroundLogin: './assets/backcolaborar.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/colaborar/frm_pagos.php',
      actualizacionLegacy: true,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/colaborar/',
      solicitudLegacy: true,
      endPointSolicitud: 'https://colaborar.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a colaborar@colaborar.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    foneps: {
      urlLogo: 'https://www.foneps.com.co/home/wp-content/uploads/2018/07/logo-foneps-1.png',
      heightLogo: 120,
      //urlEndPoint: 'http://localhost:3027/',
      urlEndPoint: 'https://app1.usabilidad.co:3027/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fonepsnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#007bff',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Foneps',
      nombreFondoCompleto: 'Fondo de empleados de Publicaciones Semana',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/foneps/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/colaborar/',
      solicitudLegacy: true,
      endPointSolicitud: 'https://colaborar.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fedane: {
      urlLogo: 'http://fedane.com/MSmedia/LogoHorizontal.png',
      heightLogo: 70,
      //urlEndPoint: 'http://localhost:3005/',
      urlEndPoint: 'https://app1.usabilidad.co:3005/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fedanenvo/Apis/apitest/zonap/api/',
      colorMenu: 'rgb(160, 18, 53)',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fedane',
      nombreFondoCompleto: 'Fondo de empleados del DANE',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fedane/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fedane/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fedane.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: false,
      enlaceCrearCuenta: true,
      clausula: true,
      mensageRestableceContrasena: 'Si ingresa por primera vez a nuestra zona privada, por favor active su cuenta, de lo contrario, por favor envíe un correo a fedane@dane.gov.co, solicitando el restablecimiento de su contraseña',
      porcentaje: true,
      calculoaporte: false,
      cuotaaporte: true,
      columnasactualizacion: 3,
      colorInfoClau: "",
      activClauActualiza: false,
      textClausula: "",
      actTimer: false,
      timer: 3,
      cartera: {
        cartera: {
          pagare: true,
          linea: true,
          fpago: false,
          monto: true,
          desembolso: true,
          plazo: true,
          tasa: true,
          saldo: true,
          tcuota: true,
          ncuota: false,
          cuota: true,
          pxpago: true,
          dmora: false,
          mov: true,
          plpagos: true,
          pagosft: true
        },
        mvtocartera: {
          pagare: true,
          fhamov: true,
          intc: true,
          intm: true,
          seguro: true,
          capital: true,
          total: true,
          codpl: true,
          saldo: true
        },
        plnpagos: {},
        pagosflt: {}
      },
      tarjeta: 2,
      reqAct: false,
      nombreDocumentos: "DESCARGA DE DOCUMENTOS",
      textsimu: "El valor real de la primera cuota del crédito puede variar del proyectado en esta consulta por motivos de ajuste de los intereses entre la fecha de contabilización del crédito y la fecha de la primera facturación.",
    },
    fondefam: {
      urlLogo: 'https://fondefam.com/wp-content/uploads/2021/03/logo-Fondefam-B1.png',
      heightLogo: 100,
      //urlEndPoint: 'http://localhost:3006/',
      urlEndPoint: 'https://app1.usabilidad.co:3004/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fondefam/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#007AC3',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fondefam',
      nombreFondoCompleto: 'Fondo de empleados de Famisanar',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fondefam/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fondefam/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fondefam.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedane@dane.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fedeaa: {
      urlLogo: 'https://fedeaa.com/wp-content/uploads/2021/09/Logo-1-768x201.png',
      heightLogo: 70,
      urlEndPoint: 'http://localhost:3007/',
      //urlEndPoint: 'https://app1.usabilidad.co:3007/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fedeaanvo/Apis/apitest/zonap/api/',
      colorMenu: '#183459',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: false,
      entidadNombre: 'Fedeaa',
      nombreFondoCompleto: 'Fondo de empleados de FEDEAA',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://decsis.net/fedeaa/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fedeaa/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fedeaa.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      idAnalitycs: "G-D8E5V9P4QM",
      moduloAfil: 'Afiliaciones',
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    feincol: {
      urlLogo: 'https://feincol.com/wp-content/uploads/2019/10/logo-feincol-01.png',
      heightLogo: 70,
      //urlEndPoint: 'http://localhost:3008/',
      urlEndPoint: "https://app1.usabilidad.co:3008/",
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/feincolnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#4c3686',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Feincol',
      nombreFondoCompleto: 'Fondo de Empleados de Incolbest',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/feincol/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/feincol/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://feincol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      porcentaje: true,
      calculoaporte: false,
      cuotaaporte: true,
      columnasactualizacion: 3,
      colorInfoClau: "",
      activClauActualiza: false,
      textClausula: "",
      actTimer: false,
      timer: 3,
      aportes: {
        aporte: {
          codigo: true,
          descripcion: true,
          saldo: true,
          mvtos: true
        },
        mvtos: {}
      },
      ahorros: {
        ahorro: {
          codigo: true,
          descripcion: true,
          pagap: true,
          fhaini: true,
          fhaven: true,
          fr: true,
          plazo: true,
          interes: true,
          cuota: true,
          saldo: true,
          mvtos: true
        },
        mvtos: {}
      },
      cartera: {
        cartera: {
          pagare: true,
          linea: true,
          fpago: false,
          monto: true,
          desembolso: false,
          plazo: true,
          tasa: true,
          saldo: true,
          tcuota: false,
          ncuota: false,
          cuota: true,
          pxpago: true,
          dmora: false,
          mov: true,
          plpagos: true,
          pagosft: true
        },
        mvtocartera: {
          pagare: true,
          fhamov: true,
          intc: true,
          intm: true,
          seguro: true,
          capital: true,
          total: true,
          codpl: true,
          saldo: true
        },
        plnpagos: {},
        pagosflt: {}
      },
      servicios: {
        serviciosAct: {
          contrato: true,
          linea: true,
          fpago: true,
          monto: true,
          fhades: true,
          plazo: true,
          saldo: true,
          cuota: true,
          fhaproxp: true,
          fhaven: true,
          mvtos: false
        }
      },
      simulador: {
        seguro: false,
        textInfo: '<span style="font-size: 9px; font-weight: normal; ">El valor real de la primera cuota del crédito puede variar del proyectado en esta consulta por motivos de ajuste de los intereses entre la fecha de contabilización del crédito y la fecha de la primera facturación.</span>'
      },
      actualizacion: {
        actDeclaracion: false,
        textDeclaracion: "",
      },
      reqAct: false,
      nombreDocumentos: "DESCARGA DE DOCUMENTOS",
      messageRegister: ""
    },
    fondowell: {
      urlLogo: 'https://fondowell.cyfsoluciones.co/zona/uploads/fondowell.jpg',
      heightLogo: 70,
      //urlEndPoint: 'http://localhost:3009/',
      urlEndPoint: 'https://app1.usabilidad.co:3009/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fondowellnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#c20e31',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fondowell',
      nombreFondoCompleto: 'Fondo de Empleados independence',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fondowell/frm_pagos.php',
      actualizacionLegacy: true,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fondowell/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fondowell.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: false,
      mensageRestableceContrasena: 'ATENCIÓN: Al ingresar por primera vez, debes digitar tu cédula como usuario y contraseña y seguir las instrucciones. IMPORTANTE: Debes diligenciar el formulario de actualización de datos para poder acceder a tu estado de cuenta, indicando el correo donde desees restaurar tu contraseña. También puedes cambiar de inmediato tu clave por la opción superior derecha. Más información: well@independence.com.co',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    febatco: {
      urlLogo: 'http://www.febatco.com/corte/ultimo/LOGO%20FEBATCO%20JULIO%202013-com.png',
      heightLogo: 70,
      urlEndPoint: 'http://localhost:3010/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/febatconvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#f08021',
      letraColor: '#fff',
      letraColorEnlace: '#fff',
      activaActualizacionDatos: true,
      entidadNombre: 'Febatco',
      nombreFondoCompleto: 'Fondo de Empleados de BAT Colombia',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/febatco/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/febatco/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://febatco.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma'
    },
    fagas: {
      urlLogo: './assets/logofagas.png',
      heightLogo: 70,
      //urlEndPoint: 'http://localhost:3011/',
      urlEndPoint: 'https://app1.usabilidad.co:3011/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fagasnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#347A2A',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fagas',
      nombreFondoCompleto: 'Fondo de Empleados Gas Natural',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fagas/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fagas/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fagas.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    fonasbcol: {
      urlLogo: 'https://www.fonasbcol.com/wp-content/uploads/2017/11/cropped-cropped-logo1-1.png',
      heightLogo: 70,
      urlEndPoint: 'https://backovnode.cyfsoluciones.cloud/restFonasbcol/',
      //urlEndPoint: 'https://app1.usabilidad.co:3012/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fonasbcolnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#0D1C92',
      letraColor: '#fff',
      letraColorEnlace: '#636c72',
      activaActualizacionDatos: false,
      entidadNombre: 'Fonabscol',
      nombreFondoCompleto: 'Fondo de empleados asociados a Bancolombia',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fonabscol/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fonabscol/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fonabscol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    femhel: {
      urlLogo: 'https://www.femhel.com.co/zonap/uploads/logo_femhel.png',
      heightLogo: 70,
      //urlEndPoint: 'http://localhost:3013/',
      urlEndPoint: 'https://backovnode.cyfsoluciones.cloud/restFemhel/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/femhelnvo/zonatest/ApiFon/zonap/api/',
      colorMenu: '#08425a',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Femhel',
      nombreFondoCompleto: 'Fondo de empleados del sector aéreo',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/femhel/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/femhel/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://femhel.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fonebaker: {
      urlLogo: 'https://www.fonebaker.com/wp-content/uploads/2018/10/LOGONUEVO2018.png',
      heightLogo: 70,
      urlEndPoint: 'http://localhost:3014/',
      //urlEndPoint: 'https://app1.usabilidad.co:3014/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fonebakernvo/zonatest/ApiFon/zonap/api/',
      colorMenu: '#006699',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fonebaker',
      nombreFondoCompleto: 'Fondo De Empleados de Baker Hughes',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fonebaker/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fonebaker/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fonebaker.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fonclaro: {
      urlLogo: './assets/fonclaro.png',
      heightLogo: 80,
      urlEndPoint: 'https://app1.usabilidad.co:3015/',
      //urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fonclaronvo/zonapnvo/ApiFon/zonap/api/',
      //urlEndPoint: 'http://localhost:3001/',
      //urlEndPointLegacy: 'https://backend.cyfsoluciones.com/febancol/Apis/apitest/zonap/api/',
      colorMenu: '#bc0000',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fonclaro',
      nombreFondoCompleto: 'Fondo de Empleados de Claro',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fonclaro/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fonclaro/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fonclaro.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    fedesap: {
      urlLogo: 'https://fedesap.com.co/wp-content/uploads/2021/08/logo.png',
      heightLogo: 70,
      urlEndPoint: 'http://localhost:3016/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fedesapnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#59C45C',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fedesap',
      nombreFondoCompleto: 'Fondo de Empleados ESAP',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fedesap/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fedesap/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fedesap.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fonfedepalma: {
      urlLogo: 'https://www.fonfedepalma.com/wp-content/uploads/2022/02/logo.jpeg',
      heightLogo: 70,
      //urlEndPoint: 'http://localhost:3017/',
      urlEndPoint: 'https://app1.usabilidad.co:3017/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fedepalmanvo/zonatest/ApiFon/zonap/api/',
      colorMenu: '#C3E6CB',
      letraColor: '#000',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fonfedepalma',
      nombreFondoCompleto: 'Fondo de Empleados de Fedepalma',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fonfedepalma/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fonfedepalma/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fonfedepalma.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fonleg: {
      urlLogo: './assets/logo-fonleg.png',
      heightLogo: 70,
      urlEndPoint: 'https://app1.usabilidad.co:3018/',
      urlEndPointLegacy: '',
      colorMenu: '#0541c5',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fonleg',
      nombreFondoCompleto: 'Fondo de Empleados de Legis',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fonleg/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fonleg/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fonleg.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    femsa: {
      urlLogo: 'https://www.femsa.com/assets/2019/07/femsa.png',
      heightLogo: 40,
      urlEndPoint: 'http://localhost:3019/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/femsanvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#8f191c',
      letraColor: '#fff',
      letraColorEnlace: '#fff',
      activaActualizacionDatos: true,
      entidadNombre: 'Femsa',
      nombreFondoCompleto: 'Femsa',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/femsa/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/femsa/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://femsa.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
    },
    alasmutual: {
      urlLogo: './assets/logo_alas.png',
      heightLogo: 70,
      //urlEndPoint: 'http://localhost:3020/',
      urlEndPoint: 'https://app1.usabilidad.co:3020/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/alasmutual/Apis/apitest/zonap/api/',
      colorMenu: '#5a2d83',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Alas mutual',
      nombreFondoCompleto: 'Alas',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/alas/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/alas/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://alas.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    fekonrad: {
      urlLogo: 'http://fekonradlorenz.com/wp-content/uploads/2016/06/logo.png',
      heightLogo: 70,
      urlEndPoint: 'https://localhost:3048/',
      //urlEndPoint: 'https://app1.usabilidad.co:3048/',
      urlEndPointLegacy: '',
      colorMenu: '#5882FA',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fondo de empleados Konrad Lorenz',
      nombreFondoCompleto: 'Fekonradlorenz',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    fondexxom: {
      urlLogo: 'https://fondexxom.com/wp-content/uploads/2021/01/logo-1.png',
      heightLogo: 70,
      urlEndPoint: 'http://localhost:3022/',
      //urlEndPoint: 'https://app1.usabilidad.co:3022/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fondexxom/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#2f77d6',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fondo de empleados de EXXONMOBIL',
      nombreFondoCompleto: 'Fondexxom',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fondexxom/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fondexxom/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fondexxom.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      moduloAfil: 'Afiliaciones',
      urlBannerLogin: "https://zonapfondexxom.cyfsoluciones.co/banner-actualizacion.png",
      pdfDeceval: ""
    },
    fesol: {
      urlLogo: 'https://fesol.com.co/sites/default/files/LOGO-ANIMADO-WEB-PNG-02.gif',
      heightLogo: 70,
      urlEndPoint: 'https://app1.usabilidad.co:3023/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fesolnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#ff0000',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fondo de empleados Super Tiendas Olimpica',
      nombreFondoCompleto: 'Fesol',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fesol/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fesol/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fesol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fonreginal: {
      urlLogo: 'https://www.fonreginal.com/wp-content/themes/fonreginal/img/logo.png',
      heightLogo: 70,
      //urlEndPoint: 'http://localhost:3024/',
      urlEndPoint: 'https://app1.usabilidad.co:3024/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fonreginalnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#217132',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fondo de empleados de la registraduria nacional del estado civil',
      nombreFondoCompleto: 'Fonreginal',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://fonreginal.cyfsoluciones.co/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fonreginal/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fonreginal.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fecineco: {
      urlLogo: 'https://fecineco.com/wp-content/themes/fecineco/images/logo.png',
      heightLogo: 80,
      urlEndPoint: 'http://localhost:3028/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fecineconvo/Apis/apitest/zonap/api/',
      colorMenu: '#005da9',
      letraColor: '#fff',
      activaActualizacionDatos: true,
      entidadNombre: 'Fecineco',
      nombreFondoCompleto: 'FONDO DE EMPLEADOS DE CINE COLOMBIA',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fecineco/frm_pagos.php',
      actualizacionLegacy: true,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fecineco/',
      solicitudLegacy: true,
      endPointSolicitud: 'https://fecineco.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a colaborar@colaborar.gov.co, solicitando el restablecimiento de la misma'
    },
    cooptraconalvidrios: {
      urlLogo: 'https://cooptraconalvidrios.com/wp-content/themes/tema-cooptra/img/logo.png',
      heightLogo: 80,
      urlEndPoint: 'https://app1.usabilidad.co:3030/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/cooptraconalvidrios/Apis/apitest/zonap/api/',
      colorMenu: '#2b53a1',
      letraColor: '#fff',
      activaActualizacionDatos: true,
      entidadNombre: 'Cooptraconalvidrios',
      nombreFondoCompleto: 'COOPERATIVA DE AHORRO Y CRÉDITO DE BOGOTÁ',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/cooptraconalvidrios/frm_pagos.php',
      actualizacionLegacy: true,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/cooptraconalvidrios/',
      solicitudLegacy: true,
      endPointSolicitud: 'https://cooptraconalvidrios.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a colaborar@colaborar.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Admisiones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    fondecolp: {
      urlLogo: './assets/fondecolp.jpg',
      heightLogo: 80,
      urlEndPoint: 'https://backovnode.cyfsoluciones.cloud/restFondecolp/',
      //urlEndPoint: 'https://app1.usabilidad.co:3031/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fondecolp/Apis/apitest/zonap/api/',
      colorMenu: '#508e3a',
      letraColor: '#fff',
      activaActualizacionDatos: true,
      entidadNombre: 'Fondecolp',
      nombreFondoCompleto: 'FONDO DE EMPLEADOS DE COLPENSIONES',
      backgroundLogin: './assets/backfondecolp.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: 'https://pse.cyfsoluciones.co/fondecolp/frm_pagos.php',
      actualizacionLegacy: true,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fondecolp/',
      solicitudLegacy: true,
      endPointSolicitud: 'https://fondecolp.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a colaborar@colaborar.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    febancol: {
      urlLogo: './assets/febancol.png',
      heightLogo: 70,
      urlEndPoint: 'http://localhost:3032/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/febancol/Apis/apitest/zonap/api/',
      colorMenu: '#34a02e',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Febancol',
      nombreFondoCompleto: 'Fondo de Empleados del Banco Colpatria',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://decsis.net/febancol/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/febancol/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://febancol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma'
    },
    feoracle: {
      urlLogo: 'https://www.feoracle.com.co/wp-content/uploads/2021/07/Principal_slogan_crop.png',
      heightLogo: 60,
      //urlEndPoint: 'http://localhost:3033/',
      urlEndPoint: "https://app1.usabilidad.co:3033/",
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/feincolnvo/zonapnvo/ApiFon/zonap/api/',// aqui estoy utilizando otro backend como local para las pruebas
      colorMenu: '#19989d',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Feoracle',
      nombreFondoCompleto: 'Fondo de Empleados de Oracle',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      //endPointPse: 'https://pse.cyfsoluciones.co/feincol/frm_pagos.php',
      actualizacionLegacy: false,
      //endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/feincol/',
      solicitudLegacy: false,
      //endPointSolicitud: 'https://feincol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fonulibre: {
      urlLogo: 'https://fonulibre.co/wp-content/uploads/2020/08/logo-fonulibre-oficial.png',
      heightLogo: 70,
      //urlEndPoint: 'http://localhost:3034/',
      urlEndPoint: "https://app1.usabilidad.co:3034/",
      urlEndPointLegacy: '',
      colorMenu: '#c20e31',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fonulibre',
      nombreFondoCompleto: 'FONDO NACIONAL DE EMPLEADOS DE LA UNIVERSIDAD LIBRE',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      //endPointPse: 'https://pse.cyfsoluciones.co/feincol/frm_pagos.php',
      actualizacionLegacy: false,
      //endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/feincol/',
      solicitudLegacy: false,
      //endPointSolicitud: 'https://feincol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: '',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    feroldan: {
      urlLogo: 'https://www.feroldan.com/skins/page/images/roldan4.png',
      heightLogo: 120,
      urlEndPoint: "https://app1.usabilidad.co:3035/",
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/feincolnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#c20e31',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Feroldan',
      nombreFondoCompleto: 'Fondo de Empleados de Feroldan',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      //endPointPse: 'https://pse.cyfsoluciones.co/feincol/frm_pagos.php',
      actualizacionLegacy: false,
      //endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/feincol/',
      solicitudLegacy: false,
      //endPointSolicitud: 'https://feincol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      porcentaje: false,
      calculoaporte: true,
      cuotaaporte: false,
      columnasactualizacion: 3,
      colorInfoClau: "",
      activClauActualiza: false,
      textClausula: "",
      actTimer: false,
      timer: 3, aportes: {
        aporte: {
          codigo: true,
          descripcion: true,
          saldo: true,
          mvtos: true
        },
        mvtos: {}
      },
      ahorros: {
        ahorro: {
          codigo: true,
          descripcion: true,
          pagap: true,
          fhaini: true,
          fhaven: true,
          fr: true,
          plazo: true,
          interes: true,
          cuota: true,
          saldo: true,
          mvtos: true
        },
        mvtos: {}
      },
      cartera: {
        cartera: {
          pagare: true,
          linea: true,
          fpago: false,
          monto: true,
          desembolso: false,
          plazo: true,
          tasa: true,
          saldo: true,
          tcuota: false,
          ncuota: false,
          cuota: true,
          pxpago: true,
          dmora: false,
          mov: true,
          plpagos: true,
          pagosft: true
        },
        mvtocartera: {
          pagare: true,
          fhamov: true,
          intc: true,
          intm: true,
          seguro: true,
          capital: true,
          total: true,
          codpl: true,
          saldo: true
        },
        plnpagos: {},
        pagosflt: {}
      },
      servicios: {
        serviciosActTable: false,
        serviciosAct: {
          contrato: true,
          linea: true,
          fpago: true,
          monto: true,
          fhades: true,
          plazo: true,
          saldo: true,
          cuota: true,
          fhaproxp: true,
          fhaven: true,
          mvtos: false
        }
      },
      simulador: {
        seguro: true,
        textInfo: '<span style="font-size: 9px; font-weight: normal; ">El valor real de la primera cuota del crédito puede variar del proyectado en esta consulta por motivos de ajuste de los intereses entre la fecha de contabilización del crédito y la fecha de la primera facturación.</span>'
      },
      actualizacion: {
        actDeclaracion: false,
        textDeclaracion: "",
      },
      reqAct: false,
      nombreDocumentos: "DESCARGA DE DOCUMENTOS",
      messageRegister: ""
    },
    fonwomer: {
      urlLogo: 'https://zonapafondo.cyfsoluciones.co/uploads/logo-fonwomer.png',
      heightLogo: 100,
      urlEndPoint: 'https://app1.usabilidad.co:3036/',
      urlEndPointLegacy: '',
      colorMenu: '#311E4A',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fonwomer',
      nombreFondoCompleto: 'Fondo de Empleados Wom',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: '',
      porcentaje: true,
      calculoaporte: true,
      cuotaaporte: false,
      columnasactualizacion: 3,
      colorInfoClau: "",
      activClauActualiza: false,
      textClausula: "",
      actTimer: false,
      timer: 3,
      aportes: {
        aporte: {
          codigo: true,
          descripcion: true,
          saldo: true,
          mvtos: true
        },
        mvtos: {}
      },
      ahorros: {
        ahorro: {
          codigo: true,
          descripcion: true,
          pagap: true,
          fhaini: true,
          fhaven: true,
          fr: true,
          plazo: true,
          interes: true,
          cuota: true,
          saldo: true,
          mvtos: true
        },
        mvtos: {}
      },
      cartera: {
        cartera: {
          pagare: true,
          linea: true,
          fpago: false,
          monto: true,
          desembolso: false,
          plazo: true,
          tasa: true,
          saldo: true,
          tcuota: false,
          ncuota: false,
          cuota: true,
          pxpago: true,
          dmora: false,
          mov: true,
          plpagos: true,
          pagosft: true
        },
        mvtocartera: {
          pagare: true,
          fhamov: true,
          intc: true,
          intm: true,
          seguro: true,
          capital: true,
          total: true,
          codpl: true,
          saldo: true
        },
        plnpagos: {},
        pagosflt: {}
      },
      servicios: {
        serviciosAct: {
          contrato: true,
          linea: true,
          fpago: true,
          monto: true,
          fhades: true,
          plazo: true,
          saldo: true,
          cuota: true,
          fhaproxp: true,
          fhaven: true,
          mvtos: false
        }
      },
      simulador: {
        seguro: false,
        textInfo: '<span style="font-size: 9px; font-weight: normal; ">El valor real de la primera cuota del crédito puede variar del proyectado en esta consulta por motivos de ajuste de los intereses entre la fecha de contabilización del crédito y la fecha de la primera facturación.</span>'
      },
      actualizacion: {
        actDeclaracion: false,
        textDeclaracion: "",
      },
      reqAct: false,
      nombreDocumentos: "DESCARGA DE DOCUMENTOS",
      messageRegister: ""
    },
    fempro: {
      urlLogo: 'https://www.fempro.com.co/skins/page/images/Fempro_Logos%20Color-04.png',
      heightLogo: 100,
      urlEndPoint: 'https://backovnode.cyfsoluciones.cloud/restFempro/',
      urlEndPointLegacy: '',
      colorMenu: '#71BF44',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fempro',
      nombreFondoCompleto: 'Fondo de empleados y prestadores de servicios médicos de PROFAMILIA',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fecor: {
      urlLogo: './assets/fecor-logo.jpg',
      heightLogo: 100,
      //urlEndPoint: 'https://app1.usabilidad.co:3038/',
      urlEndPoint: 'http://localhost:3038/',
      urlEndPointLegacy: '',
      colorMenu: '#900C3F',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: false,
      entidadNombre: 'Fecor',
      nombreFondoCompleto: 'Fondo de empleados  y prestadores de servicios médicos de PROFAMILIA',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      clausula: false,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    coopfiligrana: {
      urlLogo: 'http://www.coopfiligrana.com/wp-content/themes/coopfiligrana/img/logo.png',
      heightLogo: 70,
      urlEndPoint: "https://app1.usabilidad.co:3035/",
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/feincolnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: ' #aa863b',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'coopfiligrtana ',
      nombreFondoCompleto: 'Fondo de Empleados de Feroldan',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      //endPointPse: 'https://pse.cyfsoluciones.co/feincol/frm_pagos.php',
      actualizacionLegacy: false,
      //endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/feincol/',
      solicitudLegacy: false,
      //endPointSolicitud: 'https://feincol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    cooperael: {
      urlLogo: 'https://zonapcooperael.cooperael.co/uploads/logo.png',
      heightLogo: 70,
      urlEndPoint: "https://app1.usabilidad.co:3041/",
      urlEndPointLegacy: '',
      colorMenu: '#231380',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'coperal',
      nombreFondoCompleto: 'Fondo de Empleados de Feroldan',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      //endPointPse: 'https://pse.cyfsoluciones.co/feincol/frm_pagos.php',
      actualizacionLegacy: false,
      //endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/feincol/',
      solicitudLegacy: false,
      //endPointSolicitud: 'https://feincol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
    },
    feseracis: {
      urlLogo: 'https://feseracis.com/sitio/wp-content/uploads/2018/04/cropped-img40.jpg',
      heightLogo: 70,
      urlEndPoint: "https://app1.usabilidad.co:3035/",
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/feincolnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#3E40CF ',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'coperal',
      nombreFondoCompleto: '',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      //endPointPse: 'https://pse.cyfsoluciones.co/feincol/frm_pagos.php',
      actualizacionLegacy: false,
      //endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/feincol/',
      solicitudLegacy: false,
      //endPointSolicitud: 'https://feincol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      porcentaje: false,
      calculoaporte: true,
      cuotaaporte: false,
      columnasactualizacion: 3,
      colorInfoClau: "",
      activClauActualiza: false,
      textClausula: "",
      actTimer: false,
      timer: 3, aportes: {
        aporte: {
          codigo: true,
          descripcion: true,
          saldo: true,
          mvtos: true
        },
        mvtos: {}
      },
      ahorros: {
        ahorro: {
          codigo: true,
          descripcion: true,
          pagap: true,
          fhaini: true,
          fhaven: true,
          fr: true,
          plazo: true,
          interes: true,
          cuota: true,
          saldo: true,
          mvtos: true
        },
        mvtos: {}
      },
      cartera: {
        cartera: {
          pagare: true,
          linea: true,
          fpago: false,
          monto: true,
          desembolso: false,
          plazo: true,
          tasa: true,
          saldo: true,
          tcuota: false,
          ncuota: false,
          cuota: true,
          pxpago: true,
          dmora: false,
          mov: true,
          plpagos: true,
          pagosft: true
        },
        mvtocartera: {
          pagare: true,
          fhamov: true,
          intc: true,
          intm: true,
          seguro: true,
          capital: true,
          total: true,
          codpl: true,
          saldo: true
        },
        plnpagos: {},
        pagosflt: {}
      },
      servicios: {
        serviciosAct: {
          contrato: true,
          linea: true,
          fpago: true,
          monto: true,
          fhades: true,
          plazo: true,
          saldo: true,
          cuota: true,
          fhaproxp: true,
          fhaven: true,
          mvtos: false
        }
      },
      simulador: {
        seguro: false,
        textInfo: '<span style="font-size: 9px; font-weight: normal; ">El valor real de la primera cuota del crédito puede variar del proyectado en esta consulta por motivos de ajuste de los intereses entre la fecha de contabilización del crédito y la fecha de la primera facturación.</span>'
      },
      actualizacion: {
        actDeclaracion: false,
        textDeclaracion: "",
      },
      reqAct: false,
      nombreDocumentos: "DESCARGA DE DOCUMENTOS",
      messageRegister: ""
    },
    femsar: {
      urlLogo: 'https://www.femsar.com/wp-content/themes/femsar/images/logo.png',
      heightLogo: 70,
      urlEndPoint: "https://backovnode.cyfsoluciones.cloud/restFemsar/",
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/feincolnvo/zonapnvo/ApiFon/zonap/api/',
      colorMenu: '#043a72',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'femsar',
      nombreFondoCompleto: '',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      //endPointPse: 'https://pse.cyfsoluciones.co/feincol/frm_pagos.php',
      actualizacionLegacy: false,
      //endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/feincol/',
      solicitudLegacy: false,
      //endPointSolicitud: 'https://feincol.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    fesdis: {
      urlLogo: 'https://zonapfesdis.cyfsoluciones.co/uploads/V1A-Imagen_retina-.png',
      heightLogo: 100,
      urlEndPoint: 'https://app1.usabilidad.co:3040/',
      urlEndPointLegacy: '',
      colorMenu: '#76BC21',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Cyf',
      nombreFondoCompleto: 'Cyf soluciones',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: false,
      clausula: false,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    coomerca: {
      urlLogo: './assets/logo-coomerca.png',
      heightLogo: 70,
      urlEndPoint: 'https://app1.usabilidad.co:3045/',
      //urlEndPoint: 'http://localhost:3045/',
      urlEndPointLegacy: '',
      colorMenu: '#086944',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Credicoomerca',
      nombreFondoCompleto: 'Credicoomerca',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    coomercaMutual: {
      urlLogo: './assets/coomercaMutual.png',
      heightLogo: 200,
      //urlEndPoint: 'https://app1.usabilidad.co:3045/',
      urlEndPoint: 'http://localhost:3051/',
      urlEndPointLegacy: '',
      colorMenu: '#086944',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Credicoomerca',
      nombreFondoCompleto: 'Credicoomerca',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    fsv: {
      urlLogo: './assets/fsvLogo.jpeg',
      heightLogo: 150,
      //urlEndPoint: 'https://zonaprivadafsv.registraduria.gov.co/',
      urlEndPoint: 'http://localhost:3047/',
      urlEndPointLegacy: '',
      colorMenu: '#163359',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fonvivienda',
      nombreFondoCompleto: 'Fondo Nacional de Vivienda',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: '',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fepar: {
      urlLogo: './assets/logo-coomerca.png',
      heightLogo: 70,
      urlEndPoint: 'https://app1.usabilidad.co:3001/',
      urlEndPointLegacy: '',
      colorMenu: '#086944',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Credicoomerca',
      nombreFondoCompleto: 'Credicoomerca',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    coopsuperfinanciera: {
      urlLogo: './assets/Logo-coopsuperfinanciera.png',
      heightLogo: 70,
      urlEndPoint: 'https://app1.usabilidad.co:3052/',
      urlEndPointLegacy: '',
      colorMenu: '#088044',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Coopsuperfinanciera',
      nombreFondoCompleto: 'Coopsuperfinanciera',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: ""
    },
    fondec: {
      urlLogo: 'https://www.fondec.com/images/2019/05/25/logo-fondec-b.png',
      heightLogo: 70,
      urlEndPoint: 'http://localhost:3053/',
      //urlEndPoint: 'https://app1.usabilidad.co:3053/',
      urlEndPointLegacy: 'https://backend.cyfsoluciones.com/fedeaanvo/Apis/apitest/zonap/api/',
      colorMenu: '#e31a26',
      letraColor: '#fff',
      letraColorEnlace: '#000',
      activaActualizacionDatos: false,
      entidadNombre: 'Fondec',
      nombreFondoCompleto: 'Fondo de empleados de FONDEC',
      backgroundLogin: './assets/backcolaborar.jpg',
      claseUbicacionCajaLogin: 'mx-auto',
      endPointPse: 'https://decsis.net/fedeaa/frm_pagos.php',
      actualizacionLegacy: false,
      endPointActualizacion: 'https://actualizacion.cyfsoluciones.com/fedeaa/',
      solicitudLegacy: false,
      endPointSolicitud: 'https://fedeaa.cyfsoluciones.co/solicitudes/index.php',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      idAnalitycs: "G-D8E5V9P4QM",
      moduloAfil: 'Afiliaciones',
      urlBannerLogin: ""
    },
    fondek: {
      urlLogo: './assets/logo-fondek.png',
      heightLogo: 70,
      urlEndPoint: 'http://localhost:3054/',
      //urlEndPoint: 'https://Apifondekbk.co.kworld.kpmg.com:3054/',
      urlEndPointLegacy: '',
      colorMenu: '#020873',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Fondek',
      nombreFondoCompleto: 'Kdefon',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
    fedoc: {
      urlLogo: 'https://fedoc.co/wp-content/uploads/2020/06/logo_png.png',
      heightLogo: 100,
      urlEndPoint: 'http://localhost:3056/',
      urlEndPointLegacy: '',
      colorMenu: '#233972',
      letraColor: '#FFF',
      letraColorEnlace: '#000',
      activaActualizacionDatos: true,
      entidadNombre: 'Cyf',
      nombreFondoCompleto: 'Cyf soluciones',
      backgroundLogin: './assets/back.jpg',
      claseUbicacionCajaLogin: 'ml-auto',
      endPointPse: '',
      actualizacionLegacy: false,
      endPointActualizacion: '',
      solicitudLegacy: false,
      endPointSolicitud: '',
      enlaceRestableceContrasena: true,
      enlaceCrearCuenta: true,
      mensageRestableceContrasena: 'En caso de olvidar su contraseña, por favor enviar un correo a fedeaa@fedeaa.gov.co, solicitando el restablecimiento de la misma',
      moduloAfil: 'Afiliaciones',
      idAnalitycs: "",
      urlBannerLogin: "",
      pdfDeceval: ""
    },
  }
};
